var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5214",
    "data-name": "Group 5214",
    transform: "translate(20761 13034)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1629",
    "data-name": "Rectangle 1629",
    width: 24,
    height: 24,
    transform: "translate(-20761 -13034)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-code-1694652",
    transform: "translate(-20762.773 -13035.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5210",
    "data-name": "Group 5210",
    transform: "translate(4.266 4.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13129",
    "data-name": "Path 13129",
    d: "M45.508,30.18a.37.37,0,0,0-.47.253L42.8,37.9a.373.373,0,1,0,.711.216l2.239-7.463A.373.373,0,0,0,45.508,30.18Z",
    transform: "translate(-34.768 -24.779)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13130",
    "data-name": "Path 13130",
    d: "M24.9,32.969a.374.374,0,0,0-.535.02l-2.985,3.172a.373.373,0,0,0,0,.507l2.985,3.172a.373.373,0,1,0,.548-.507l-2.746-2.915L24.911,33.5A.373.373,0,0,0,24.9,32.969Z",
    transform: "translate(-17.742 -26.921)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13131",
    "data-name": "Path 13131",
    d: "M61.4,32.988a.373.373,0,1,0-.548.507L63.6,36.416l-2.746,2.915a.373.373,0,1,0,.548.507l2.985-3.172a.373.373,0,0,0,0-.507Z",
    transform: "translate(-49.01 -26.92)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13132",
    "data-name": "Path 13132",
    d: "M13.773,4.266a9.507,9.507,0,1,0,9.507,9.507A9.517,9.517,0,0,0,13.773,4.266Zm0,18.267a8.76,8.76,0,1,1,8.76-8.76A8.77,8.77,0,0,1,13.773,22.533Z",
    transform: "translate(-4.266 -4.266)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularCodeIcon);
export default __webpack_public_path__ + "static/media/CircularCodeIcon.5e86be71d1d99f9b4326244f8f8af38a.svg";
export { ForwardRef as ReactComponent };